import _ from "lodash";
import { Types } from "./timemotoActions";

const timemotoReducers = (state, action) => {
    switch (action.type) {
        case Types.TIMEMOTO_CONNECT: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                timeMoto: {
                    ...newState.integration?.timeAttendance?.timeMoto,
                    connecting: action.status
                }
            }

            return newState;
        }
        case Types.TIMEMOTO_GET_PUNCH_CLOCKS: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                timeMoto: {
                    ...newState.integration?.timeAttendance?.timeMoto,
                    punchClocks: action.data
                }
            }

            return newState;
        }
        case Types.TIMEMOTO_SAVING: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                timeMoto: {
                    ...newState.integration?.timeAttendance?.timeMoto,
                    saving: action.status
                }
            }

            return newState;
        }
        case Types.TIMEMOTO_LOADING: {

            let newState = _.cloneDeep(state);

            newState.integration.timeAttendance = {
                ...newState?.integration?.timeAttendance,
                timeMoto: {
                    ...newState.integration?.timeAttendance?.timeMoto,
                    loading: action.status
                }
            }

            return newState;
        }
        default:
            return state;
    }
};

export default timemotoReducers;